import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';

import UserAddressCreateUpdate from '../../../../../components/global/user-address/UserAddressCreateUpdate';
import useCheckoutCartAddress from './hooks/useCheckoutCartAddress';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    addresses: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ),
  }),
  address: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  checkoutItems: PropTypes.object,
};

const CheckoutCartAddress = ({ account, checkoutItems }) => {
  const [address] = account?.addresses ?? [];
  const {
    createAccountAddress,
    updateAccountAddress,
  } = useCheckoutCartAddress({ account, address, checkoutItems });

  return (
    <Element name="checkout-shipping-address">
      <div className="mb-4">
        <h3 className="text-extra-bold text-faded">Ship to</h3>
        <UserAddressCreateUpdate
          userId={account?.id}
          address={address}
          updateAccountAddress={updateAccountAddress}
          createAccountAddress={createAccountAddress}
        />
      </div>
    </Element>
  );
};

CheckoutCartAddress.propTypes = propTypes;

export default CheckoutCartAddress;
